import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTractorDiagramLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 286,
	height: 363,
	viewBox: "0 0 286 363",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M235 84C235 86.2091 233.209 88 231 88H219C216.791 88 215 86.2091 215 84V63H211V84C211 86.2091 209.209 88 207 88H195C192.791 88 191 86.2091 191 84V63L95 63V84C95 86.2091 93.2091 88 91 88H79C76.7909 88 75 86.2091 75 84V63H71V84C71 86.2091 69.2091 88 67 88L55 88C52.7909 88 51 86.2091 51 84V35C51 32.7909 52.7909 31 55 31H67C69.2091 31 71 32.7909 71 35V55H75V35C75 32.7909 76.7909 31 79 31L91 31C93.2091 31 95 32.7909 95 35V55L191 55V35C191 32.7909 192.791 31 195 31L207 31C209.209 31 211 32.7909 211 35V55H215V35C215 32.7909 216.791 31 219 31H231C233.209 31 235 32.7909 235 35V84Z",
			fill: "#5D5D5D"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 243,
			y: 159,
			width: 104,
			height: 36,
			rx: 10,
			transform: "rotate(90 243 159)",
			fill: "#5D5D5D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M240 256L225 246L210 256",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241 246L225 236L209 246",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241 236L225 225L209 236",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241 225L225 214L209 225",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241 214L225 204L209 214",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241 204L225 193L209 204",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241 193L225 182L209 193",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241 182L225 172L209 182",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241 172L225 161L209 172",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 79,
			y: 159,
			width: 104,
			height: 36,
			rx: 10,
			transform: "rotate(90 79 159)",
			fill: "#5D5D5D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77 256L62 246L47 256",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77 246L61 236L45 246",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77 236L61 225L45 236",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77 225L61 214L45 225",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77 214L61 204L45 214",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77 204L61 193L45 204",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77 193L61 182L45 193",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77 182L61 172L45 182",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77 172L61 161L45 172",
			stroke: "#3D4951",
			strokeWidth: 3,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M185 19L199 130H87L101 19L185 19Z",
			fill: "#A9431E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91 276C84.3726 276 79 270.627 79 264V164H79.2295L87 130H103.09L113 19L173 19L182.911 130H199L206.771 164H207L207 264C207 270.627 201.627 276 195 276H91Z",
			fill: "#C57C62"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M192 134L199 160H87L94 134H192Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223 165C223 166.657 221.657 168 220 168H199V229C199 230.657 197.657 232 196 232H194C192.343 232 191 230.657 191 229V168H94V229C94 230.657 92.6569 232 91 232H89C87.3431 232 86 230.657 86 229V168H67C65.3431 168 64 166.657 64 165V159C64 157.343 65.3431 156 67 156H220C221.657 156 223 157.343 223 159V165Z",
			fill: "#F1EAEA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M163 286C163 287.657 161.657 289 160 289H126C124.343 289 123 287.657 123 286L123 244C123 242.343 124.343 241 126 241H160C161.657 241 163 242.343 163 244V286Z",
			fill: "#F1EAEA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5 19L12.5 136.5",
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 160L12 289",
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 224.5,
			y1: .5,
			x2: 224.5,
			y2: 308.5,
			stroke: "#27CBC0",
			strokeLinecap: "round",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M274.5 59V123.5",
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M274.5 147.5V211",
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M274.5 27.5V19",
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M274.5 59V50.75",
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 243.5,
			y1: .5,
			x2: 243.5,
			y2: 350.5,
			stroke: "#27CBC0",
			strokeLinecap: "round",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 60.5,
			y1: .5,
			x2: 60.5,
			y2: 309.5,
			stroke: "#27CBC0",
			strokeLinecap: "round",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 42.5,
			y1: .5,
			x2: 42.5,
			y2: 350.5,
			stroke: "#27CBC0",
			strokeLinecap: "round",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M275 59L31 59",
			stroke: "#27CBC0",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M275 211L31 211",
			stroke: "#27CBC0",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M275 19L12 19",
			stroke: "#27CBC0",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M273 289H12",
			stroke: "#27CBC0",
			strokeDasharray: "6 6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M225 309H153",
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.5 309H61",
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M244 351H153",
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.5 351H42",
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 262.5,
			y: 123.5,
			width: 23,
			height: 23,
			rx: 11.5,
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M270.789 140.161V139.266L274.149 135.587C274.544 135.156 274.869 134.781 275.124 134.463C275.379 134.142 275.568 133.84 275.691 133.558C275.817 133.273 275.879 132.975 275.879 132.663C275.879 132.306 275.793 131.996 275.621 131.734C275.452 131.472 275.22 131.27 274.925 131.127C274.63 130.985 274.299 130.913 273.931 130.913C273.54 130.913 273.198 130.995 272.906 131.157C272.618 131.316 272.394 131.54 272.235 131.828C272.08 132.117 272.002 132.455 272.002 132.842H270.828C270.828 132.246 270.966 131.722 271.241 131.271C271.516 130.821 271.891 130.469 272.365 130.217C272.842 129.966 273.377 129.84 273.97 129.84C274.567 129.84 275.096 129.966 275.556 130.217C276.017 130.469 276.378 130.809 276.64 131.237C276.902 131.664 277.033 132.14 277.033 132.663C277.033 133.038 276.965 133.404 276.829 133.762C276.696 134.117 276.464 134.513 276.133 134.95C275.805 135.385 275.349 135.915 274.766 136.541L272.479 138.987V139.067H277.212V140.161H270.789Z",
			fill: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 130.5,
			y: 297.5,
			width: 23,
			height: 23,
			rx: 11.5,
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.321 312.003V310.989L141.795 303.909H142.531V305.48H142.034L138.653 310.83V310.909H144.679V312.003H137.321ZM142.113 314.091V303.909H143.287V314.091H142.113Z",
			fill: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 130.5,
			y: 339.5,
			width: 23,
			height: 23,
			rx: 11.5,
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M141.901 356.16C141.317 356.16 140.792 356.044 140.325 355.812C139.857 355.58 139.483 355.262 139.201 354.858C138.919 354.453 138.765 353.993 138.739 353.476H139.932C139.978 353.936 140.187 354.318 140.558 354.619C140.933 354.917 141.38 355.067 141.901 355.067C142.318 355.067 142.69 354.969 143.014 354.773C143.342 354.578 143.599 354.309 143.785 353.968C143.974 353.623 144.068 353.234 144.068 352.8C144.068 352.355 143.971 351.959 143.775 351.611C143.583 351.26 143.318 350.983 142.98 350.781C142.641 350.579 142.255 350.476 141.821 350.473C141.51 350.47 141.19 350.518 140.862 350.617C140.534 350.713 140.263 350.837 140.051 350.99L138.898 350.851L139.514 345.839H144.804V346.933H140.548L140.19 349.936H140.25C140.459 349.77 140.721 349.633 141.036 349.523C141.351 349.414 141.679 349.359 142.02 349.359C142.643 349.359 143.198 349.508 143.686 349.807C144.176 350.102 144.561 350.506 144.839 351.02C145.121 351.533 145.261 352.12 145.261 352.78C145.261 353.429 145.116 354.009 144.824 354.52C144.536 355.027 144.138 355.428 143.631 355.723C143.124 356.015 142.547 356.16 141.901 356.16Z",
			fill: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: 136.5,
			width: 23,
			height: 23,
			rx: 11.5,
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.01 153.23C11.3538 153.23 10.7688 153.117 10.2551 152.892C9.74464 152.667 9.33863 152.353 9.03702 151.952C8.73873 151.548 8.57632 151.079 8.5498 150.545H9.80265C9.82916 150.873 9.94185 151.157 10.1407 151.395C10.3396 151.631 10.5998 151.813 10.9213 151.942C11.2427 152.072 11.599 152.136 11.9901 152.136C12.4276 152.136 12.8154 152.06 13.1535 151.908C13.4916 151.755 13.7567 151.543 13.949 151.271C14.1412 150.999 14.2373 150.685 14.2373 150.327C14.2373 149.952 14.1445 149.622 13.9589 149.337C13.7733 149.049 13.5015 148.824 13.1436 148.661C12.7856 148.499 12.3481 148.418 11.8311 148.418H11.0157V147.324H11.8311C12.2354 147.324 12.5901 147.251 12.895 147.105C13.2032 146.959 13.4435 146.754 13.6159 146.489C13.7915 146.223 13.8794 145.912 13.8794 145.554C13.8794 145.209 13.8031 144.909 13.6507 144.654C13.4982 144.399 13.2828 144.2 13.0044 144.057C12.7293 143.915 12.4044 143.844 12.0299 143.844C11.6786 143.844 11.3472 143.908 11.0356 144.038C10.7274 144.163 10.4755 144.347 10.2799 144.589C10.0844 144.828 9.97831 145.116 9.96174 145.454H8.76855C8.78844 144.921 8.94919 144.453 9.2508 144.052C9.55241 143.648 9.94682 143.333 10.434 143.108C10.9246 142.882 11.4632 142.77 12.0498 142.77C12.6795 142.77 13.2198 142.897 13.6705 143.153C14.1213 143.404 14.4677 143.738 14.7096 144.152C14.9516 144.566 15.0725 145.014 15.0725 145.494C15.0725 146.068 14.9217 146.556 14.6201 146.961C14.3218 147.365 13.9158 147.645 13.4021 147.801V147.881C14.0451 147.987 14.5472 148.26 14.9085 148.701C15.2697 149.138 15.4504 149.68 15.4504 150.327C15.4504 150.88 15.2996 151.377 14.998 151.818C14.6997 152.256 14.292 152.6 13.7749 152.852C13.2579 153.104 12.6696 153.23 12.01 153.23Z",
			fill: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 262.5,
			y: 27.5,
			width: 23,
			height: 23,
			rx: 11.5,
			stroke: "#27CBC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M275.389 33.9092V44.091H274.156V35.2018H274.097L271.611 36.8524V35.5995L274.156 33.9092H275.389Z",
			fill: "#27CBC0"
		})
	]
});
export default SvgTractorDiagramLight;
